import { graphql } from "gatsby";
import { Trans } from "gatsby-plugin-react-i18next";
import React from "react";

export default function History() {
  return (
    <div className="px-4 px-md-3">
      <h1 className="my-5 text-center">
        <Trans>Um pouco da nossa História</Trans>
      </h1>

      <p className="fs-5">
        Com sede numa das cidades mais ancestrais do norte de Portugal, situada num dos trechos mais belos do rio Tâmega, abraçada pelas
        Serras do Marvão e da Aboboreira, uma cidade onde a cultura e a história caminham lado a lado.
      </p>
      <p className="fs-5">Não podemos deixar de falar das nossas origens quando pertencemos a cidade de Amarante.</p>
      <p className="fs-5">Há 18 anos lado a lado com profissionais de excelência que consideramos parte da nossa família.</p>
      <p className="fs-5">
        Audácia começou por ser uma empresa dedicada a compra e venda de Antiguidades, Mobiliário rustico e clássico, Arte sacra, linhos
        entre outros.
      </p>
      <p className="fs-5">
        Mas a busca por uma constante evolução e a vontade inigualável de satisfazer e acompanhar os nossos clientes, fez nos expandir os
        nossos horizontes.
      </p>
      <p className="fs-5">
        Dedicando nos assim á comercialização de mobiliário feito á medida de cada cliente, sendo cada peça única exclusiva com garantia
        vitalícia.
      </p>
      <p className="fs-5">
        O nosso lema é definido por uma frase de Phillipp Kotler: «(…) A melhor propaganda é feita por clientes satisfeitos (…)», ou seja,
        nós não lutamos para ter grandes clientes, mas trabalhamos para conquistar bons e fiéis amigos.
      </p>

      <div className="our-brand d-flex flex-column align-items-center">
        <h2 className="mt-5 mb-3 text-center">
          <Trans>A nossa marca</Trans>
          <small className="ms-3 text-muted strong">( audácia mobiliário )</small>
        </h2>

        <img src="/ourBrand.jpg" width="60%" className="img-fluid" alt="Our Brand"></img>
      </div>
    </div>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
